import type {
  AppCategorySummary,
  AppSummary,
} from "@/features/app-studio/model/appsSlice";

export const FAVORITES_SECTION_ID = "favorites";

export type AppsByCategory = {
  categoryId: number;
  categoryName: string;
  apps: AppSummary[];
};

export function isAppFavorite(app: AppSummary) {
  return app.is_favorite === true;
}

export function filterAppsBySearch(apps: AppSummary[], searchQuery: string | undefined) {
  const trimmed = searchQuery?.trim();
  if (!trimmed) {
    return apps;
  }
  const needle = trimmed.toLowerCase();
  return apps.filter((app) => app.name.toLowerCase().includes(needle));
}

export function groupAppsByCategory(
  apps: AppSummary[],
  categories: AppCategorySummary[],
  unknownCategoryLabel: string,
): AppsByCategory[] {
  const categoryNameById = new Map(categories.map((category) => [category.id, category.name]));
  const groups = new Map<number, AppSummary[]>();

  for (const app of apps) {
    const existing = groups.get(app.category_id) ?? [];
    existing.push(app);
    groups.set(app.category_id, existing);
  }

  return Array.from(groups.entries())
    .map(([categoryId, categoryApps]) => ({
      categoryId,
      categoryName: categoryNameById.get(categoryId) ?? unknownCategoryLabel,
      apps: categoryApps,
    }))
    .sort((left, right) => left.categoryName.localeCompare(right.categoryName));
}
